<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import PoliciesAPI from "@/services/standards/policies/policiesAPI";
import CheckModal from "@/components/CheckModal";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import Table from "@/components/standard/SGSSTPolicies/components/PoliciesTable";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"

/**
 * Form elements component
 */
export default {
  page: {
    title:
      "2.1.1 Política del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title:
        "2.1.1 Política del SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "2.1.1 Politica del SG SST",
          active: true,
        },
      ],

      companyID: this.$store.getters["company/getCompany"].id || null,
      socialReason: this.$store.getters["company/getCompany"].social_reason || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,

      data: {
        companies_id: this.$store.getters["company/getCompany"].id,
        link: null,
      },

      itemData: null,

      loading: false,
      loading2: true,
      file: null,
      lastId: 1,
      nit: this.$store.getters["company/getCompany"].nit || null,

      item: null,
      itemStatus: "No cumplido",

      submitted: false,

      company: null,
      responsible: null,

      employeeImplementationSST: null,
    };
  },
  validations: {
    data: {
      link: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(12)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 12)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });

      this.loading2 = false;
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 12,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });

    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    print() {
      window.location.href = "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_POLITICA_SGSST.docx";
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * Get file name with format.
     * @param {String} file Is the name the file.
     * @return {String} The new format the file name.
    */
    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getLastId() {
      PoliciesAPI.getAll(this.companyID, 1)
        .then((resp) => {
          if (resp.List.data[0]['id']) {
            this.lastId = resp.List.data[0]['id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.1.1/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.1.1/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.data.link = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading2 = true
      let response = await this.uploadDocument();
      if (response) {
        PoliciesAPI.save(this.data)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 12,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading2 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Se ha registrado con éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading2 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido registrar!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getLastId();
    this.getData();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div v-if="!loading && !loading2">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Se deberá contar con una política de Seguridad y Salud en
                      el Trabajo que evidencie el compromiso de la alta
                      dirección con la salud y seguridad de los colaboradores,
                      esta debe estar fechada y firmada por el representante
                      legal, revisada con el COPASST / Vigía y socializada con
                      todos los colaboradores. Se incluye un documento para
                      descargar con el modelo de política, se deberá ajustar,
                      firmar y subir el documento final, así como la evidencia
                      de la socialización.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="text-right">
                <button @click="print" :disabled="!allowAccess()" class="btn btn-primary mx-1" type="button"
                  id="tooltip">
                  <span class="btn-label"> <i class="bx bx-download"></i></span>
                  Descargar formato de política del SG-SST
                </button>

                <b-tooltip target="tooltip" placement="left">
                  Descargar formato de política del SG-SST
                </b-tooltip>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="row">
                  <div class="col-sm-12 form-group">
                    <b-form-group label="Evidencia" label-for="file">
                      <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                        name="file" browse-text="Buscar" required :placeholder="`Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        :class="{
                          'is-invalid': $v.data.link.$error && submitted,
                        }">
                      </b-form-file>
                      <div v-if="submitted && $v.data.link.$error">
                        <small v-if="!$v.data.link.required" class="text-danger">
                          <b>La evidencia es requerida</b>
                        </small>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="form-group text-right mr-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>

                  <button type="reset" class="btn btn-secondary mx-1">
                    Cancelar
                  </button>
                </div>
              </form>

              <hr />

              <Table :companyID="Number(companyID)" />
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
